import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PostHog captures two types of events: `}<a parentName="p" {...{
        "href": "/docs/data/anonymous-vs-identified-events"
      }}><strong parentName="a">{`anonymous`}</strong>{` and `}<strong parentName="a">{`identified`}</strong></a></p>
    <p><strong parentName="p">{`Identified events`}</strong>{` enable you to attribute events to specific users, and attach `}<a parentName="p" {...{
        "href": "/docs/product-analytics/person-properties"
      }}>{`person properties`}</a>{`. They're best suited for logged-in users.`}</p>
    <p>{`Scenarios where you want to capture identified events are:`}</p>
    <ul>
      <li parentName="ul">{`Tracking logged-in users in B2B and B2C SaaS apps`}</li>
      <li parentName="ul">{`Doing user segmented product analysis`}</li>
      <li parentName="ul">{`Growth and marketing teams wanting to analyze the `}<em parentName="li">{`complete`}</em>{` conversion lifecycle
`}</li>
    </ul>
    <p><strong parentName="p">{`Anonymous events`}</strong>{` are events without individually identifiable data. They're best suited for `}<a parentName="p" {...{
        "href": "/docs/web-analytics"
      }}>{`web analytics`}</a>{` or apps where users aren't logged in. `}</p>
    <p>{`Scenarios where you want to capture anonymous events are:`}</p>
    <ul>
      <li parentName="ul">{`Tracking a marketing website`}</li>
      <li parentName="ul">{`Content-focused sites`}</li>
      <li parentName="ul">{`B2C apps where users don't sign up or log in`}</li>
    </ul>
    <p>{`Under the hood, the key difference between identified and anonymous events is that for identified events we create a `}<a parentName="p" {...{
        "href": "/docs/data/persons"
      }}>{`person profile`}</a>{` for the user, whereas for anonymous events we do not.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Important:`}</strong>{` Due to the reduced cost of processing them, anonymous events can be up to 4x cheaper than identified ones, so we recommended you only capture identified events when needed.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      